import { ApplicationConfig, provideAppInitializer, provideZoneChangeDetection, isDevMode, inject } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import { AbstractSecurityStorage, authInterceptor, OidcSecurityService, provideAuth } from 'angular-auth-oidc-client';
import { authConfig, MyStorageService } from './auth/auth.config';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ConfirmationService, FilterService, MessageService } from 'primeng/api';
import { SuburbanSupplyPreset } from './utils/suburban-supply-theme.preset';
import { DatePipe } from '@angular/common';
import { provideServiceWorker } from '@angular/service-worker';
import { catchError, firstValueFrom, of } from 'rxjs';
import { clientDiagnosticsInterceptor } from './interceptors/client-diagnostics.interceptor';
import { recordRumError } from './monitoring/aws-rum';
import { containsNormalizedText, DIACRITIC_INSENSITIVE_CONTAINS } from './utils/search-text.util';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: SuburbanSupplyPreset,
        options: {
          darkModeSelector: false,
        },
      },
    }),
    provideAuth(authConfig),
    { provide: AbstractSecurityStorage, useClass: MyStorageService },
    provideAppInitializer(() => {
      inject(FilterService).register(DIACRITIC_INSENSITIVE_CONTAINS, containsNormalizedText);
    }),
    provideAppInitializer(() => {
      const oidcSecurityService = inject(OidcSecurityService);

      return firstValueFrom(
        oidcSecurityService.checkAuthIncludingServer().pipe(
          catchError((error) => {
            recordRumError('auth_init_check_failed', {
              app: 'rep-flow',
              source: 'app_initializer',
              message: error instanceof Error ? error.message : String(error),
            });
            oidcSecurityService.logoffLocal();
            return of(undefined);
          }),
        ),
      );
    }),
    provideHttpClient(withInterceptors([authInterceptor(), clientDiagnosticsInterceptor])),
    MessageService,
    ConfirmationService,
    DatePipe,
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    // To preserve state on home page
    // { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
  ],
};
